module.exports = __webpack_public_path__ + "static/media/mq.bfeadb02.svg";